import { StatusChipText } from '@labrav/react-components'
import { ResellerAgreementStatus } from '../../types/flyout'

export const getStatusAndLabelForResale = (
  status: ResellerAgreementStatus,
  draft?: boolean
) => {
  if (status === ResellerAgreementStatus.IN_PROGRESS && draft === true) {
    return {
      textColor: StatusChipText.GRAY,
      label: 'Draft',
    }
  }
  switch (status) {
    case ResellerAgreementStatus.ACTIVE:
      return {
        textColor: StatusChipText.GREEN,
        label: 'Active',
      }
    case ResellerAgreementStatus.IN_PROGRESS:
      return {
        textColor: StatusChipText.GRAY,
        label: 'In progress',
      }
    case ResellerAgreementStatus.EXPIRED:
      return {
        textColor: StatusChipText.RED,
        label: 'Ended',
      }
    case ResellerAgreementStatus.RESTRICTED:
      return {
        textColor: StatusChipText.RED,
        label: 'Deactivated',
      }
    case ResellerAgreementStatus.DEACATIVATION_IN_PROGRESS:
      return {
        textColor: StatusChipText.YELLOW,
        label: 'Deactivation in progress',
      }
    case ResellerAgreementStatus.COMPLETED:
      return {
        textColor: StatusChipText.LIGHTBLUE,
        label: 'Completed',
      }
    case ResellerAgreementStatus.CHANNEL_OFFER_ACCEPTED:
      return {
        textColor: StatusChipText.LIGHTBLUE,
        label: 'Accepted',
      }
    case ResellerAgreementStatus.DRAFT:
      return {
        textColor: StatusChipText.GRAY,
        label: 'Draft',
      }
    case ResellerAgreementStatus.FAILED:
      return {
        textColor: StatusChipText.RED,
        label: 'Failed',
      }
    case ResellerAgreementStatus.DEACATIVATED:
      return {
        textColor: StatusChipText.RED,
        label: 'Deactivated',
      }
    case ResellerAgreementStatus.OFFER_IN_DRAFT:
      return {
        textColor: StatusChipText.GRAY,
        label: 'Draft',
      }
    case ResellerAgreementStatus.OFFER_CREATION_IN_PROGRESS:
      return {
        textColor: StatusChipText.LIGHTBLUE,
        label: 'In progress',
      }
    case ResellerAgreementStatus.OFFER_CREATION_FAILED:
      return {
        textColor: StatusChipText.RED,
        label: 'Failed',
      }
    case ResellerAgreementStatus.OFFER_SENT_RESELLER:
      return {
        textColor: StatusChipText.LIGHTBLUE,
        label: 'Sent to reseller',
      }
    case ResellerAgreementStatus.OFFER_VIEWED_RESELLER:
      return {
        textColor: StatusChipText.LIGHTBLUE,
        label: 'Viewed by reseller',
      }
    case ResellerAgreementStatus.OFFER_EXTENDED_TO_BUYER:
      return {
        textColor: StatusChipText.LIGHTBLUE,
        label: 'Extended to buyer',
      }
    case ResellerAgreementStatus.OFFER_TERMS_ACCEPTED_BUYER:
      return {
        textColor: StatusChipText.YELLOW,
        label: 'Pending purchase',
      }
    case ResellerAgreementStatus.OFFER_PURCHASE_COMPLETE:
      return {
        textColor: StatusChipText.GRAY,
        label: 'Pending account configuration',
      }
    case ResellerAgreementStatus.OFFER_ACCEPTED:
      return {
        textColor: StatusChipText.GREEN,
        label: 'Accepted',
      }
    case ResellerAgreementStatus.OFFER_EXPIRED:
      return {
        textColor: StatusChipText.RED,
        label: 'Expired',
      }
    case ResellerAgreementStatus.OFFER_RESTRICTION_IN_PROGRESS:
      return {
        textColor: StatusChipText.RED,
        label: 'Deactivation in progress',
      }
    case ResellerAgreementStatus.OFFER_RESTRICTED:
      return {
        textColor: StatusChipText.RED,
        label: 'Deactivated',
      }
    default:
      return {
        textColor: StatusChipText.RED,
        label: 'Failed',
      }
  }
}
